import ModalCreerPatient from "@/components/creer-patient-modal";
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';

import store_patient from "@/store/mods/clinique/patients"
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

import $ from 'jquery'

export default {
    name: 'manage-depot-modal',
    components: {
        ModalCreerPatient, VueHtml2pdf, EnteteBonEtFacture
    },
    props: {
        historique: Object,
        toggle_list: Boolean,
        compte_id: Number
    },
    data() {
        return {
            p_is_loading: true,
            p_is_empty: false,
            save_loading: false,
            historique_depot: [],
            historique_depense: [],
            montant_a_verser: '',
            error_message: '',
            next_to_confirm: false,

            filename: 'Dépôt',
            info_depot: {},


            filter: "",
            perPage: -1,
            currentPage: 1,
            total_pages: 0,
            fields: [
                { key: 'patient', label: 'Patients' }, { key: 'sexe', label: 'Sexes' }, 
                { key: 'telephone', label: 'Téléphones' }, 'action.s'
            ],

            histo_fields: [
                'date', 'prestation', { key: 'montant', label: 'Montant' }
            ],
            histo_depot_fields: [
                'date', { key: 'ref', label: 'Référence' }, { key: 'deposant', label: 'Déposant' }, 'contact',
                { key: 'montant', label: 'Montant' }
            ],


            is_form: false,

            options: { placeholder: "Ex. 90 00 00 00", maxlength: 11 },
            tel_is_required: false,
            country_code: '',
            prefered_countries: [this.default_country_code],
            only_countries: ['tg', 'bj', 'ci'],

            deposit: {
                user_id: 0,
                patient_id: 0,
                patient_nom: '',
                deposant_nom: '',
                indicatif: '',
                deposant_tel: '',
                montant: ''
            },

            is_loading: true,
            is_empty: false,
            depense_is_loading: true,
            depense_is_empty: false,

            to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: true,
			del_loading: false,

            patients: [],
            search_filter: {
                with_consultation: false
            },
            info_patient: {}
        }
    },

    watch: {
        historique() {
            this.getHistoriqueDepot()
            this.getHistoriqueDepense()
        },

        toggle_list() {
            this.getListePatients()
        },

        filter() {
            if (this.filter == '') {
                this.search_filter.search_term = ''
                this.getListePatients()
            }
        } 
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        if (this.has_two_currencies) {
            this.currency_info = this.$store.getters['info_currency']
        }

        this.info_caissier = {
            nom_caissier: this.userCredentials.user.name,
            titre: this.userCredentials.user.titre
        }
    },

    methods: {
        getListePatients() {
            this.p_is_loading = true
            this.patients = []

            store_patient.getListeAllPatient(this.search_filter).then((patients) => {
                this.patients = patients.data
                this.total_pages = patients.last_page
                if (this.patients.length > 0) {
                    this.p_is_empty = false
                } else {
                    this.p_is_empty = true
                }
                this.p_is_loading = false
            })
        },

        goToDepositForm(p) {
            this.deposit.patient_id = parseInt(p.patient_id)
            this.deposit.patient_nom = p.patient_nom
            this.deposit.patient_telephone = p.patient_telephone

            this.info_patient = {
                nom_patient: p.patient_nom,
                sexe: p.sexe
            }

            this.is_form = true
        },

        backToListePatient() {
            this.is_form = false
        },

        countryChanged(country) {
            this.country_code = '+' + country.dialCode
        },

        async submit() {
            const isValid = await this.$refs.deposit_form.validate();

            if (!isValid) {
                return;
            }
            this.save_loading = true

            this.deposit.indicatif = this.country_code
            this.deposit.user_id = this.userCredentials.user.id
            this.deposit.compte_id = this.compte_id
            this.deposit.info_caissier = this.info_caissier
            this.deposit.info_patient = this.info_patient

            this.$store.dispatch('saveDepot', this.deposit).then((response) => {
                if (response > 0) {
                    this.successToast("Dépôt ajouté avec succès")
                    this.is_form = false

                   
                    this.$emit('emitDepot')

                    this.$refs.deposit_form.reset();
                    this.$refs.modalDepot.click();

                    this.deposit = {
                        user_id: 0,
                        patient_id: 0,
                        patient_nom: '',
                        deposant_nom: '',
                        indicatif: '',
                        deposant_tel: '',
                        montant: ''
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
            })
        },

        getHistoriqueDepot() {
            this.is_loading = true

            setTimeout(() => {
                this.is_loading = false
                this.historique_depot = this.historique.historique_depot
                if (this.historique_depot.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
            }, 500);
        },

        getHistoriqueDepense() {
            this.depense_is_loading = true

            setTimeout(() => {
                this.depense_is_loading = false
                this.historique_depense = this.historique.historique_depense
                if (this.historique_depense.length == 0) {
                    this.depense_is_empty = true
                } else {
                    this.depense_is_empty = false
                }
            }, 500);
        },

        setToDelete(c) {
            this.to_be_deleted = {
                id: c.depot_id,
                patient: this.historique.patient,
                montant: c.montant
            }
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteItem', this.to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast("Dépôt supprimé avec succès")
                    this.$emit('emitDepot')
                    
                    this.is_confirm = false
                    this.$refs.depotDelModal.click();
                    this.$refs.modalHistoDepot.click();
                }
                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
            })
        },

        printRecu(d) {
            this.filename = 'Dépôt_'+this.historique.patient
            this.info_depot = d

            this.$refs.html2Pdf.generatePdf()
        },

        onDeposantMeme(selector) {
            let est_lui_meme = document.getElementById(selector);

            let new_tel = ''

            let tel = this.deposit.patient_telephone
            if (tel != null && tel != '') {
                tel = tel.split(" ")
                new_tel = tel.slice(1).join(' ');
            }
            
            if (est_lui_meme.checked) { 
                this.deposit.deposant_nom = this.deposit.patient_nom
                this.deposit.deposant_tel = (this.deposit.patient_telephone != null)?this.deposit.patient_telephone:''
                
                setTimeout(() => {
                    this.deposit.deposant_tel = new_tel
                }, 500);
            } else {
                this.deposit.deposant_nom = ''
                this.deposit.deposant_tel = ''
            }
        },

        handlePayBack(selector) {
            const montant_is_empty = this.validateStringNotEmpty(this.montant_a_verser)
            let montant_a_verser = 0

            if (montant_is_empty) {
                this.error_message = "Merci de saisir un nombre"
                return;
            }

            montant_a_verser = this.cleanNumber(this.montant_a_verser)
            const is_greater_zero = this.checkIfNumberGreaterThanZero(montant_a_verser)

            if (!is_greater_zero) {
                this.error_message = "Merci de saisir un nombre supérieur à zéro"
                return;
            }

            if (montant_a_verser > this.historique.montant_restant) {
                this.error_message = "Le montant doit être inférieur ou égal au solde du dépôt patient !"
                return;
            }

            if (!this.next_to_confirm) {
                this.next_to_confirm = true
                return;
            }
            
            let confirm = document.getElementById(selector);
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé
                $('.err-msg').fadeIn(500)
                return;
            }

            const data = {
                user_id: this.userCredentials.user.id,
                patient_id: this.historique.patient_id,
                montant_initial: this.historique.montant_restant,
                montant_a_verser: montant_a_verser,
                montant_restant: this.historique.montant_restant - montant_a_verser,
                compte_id: this.compte_id
            }
            this.save_loading = true
            this.$store.dispatch('payBackDepotPatient', data).then((response) => {
                if (response.success) {
                    this.$emit('emitDepot')
                    this.$refs.reverser_depot.click()
                    this.montant_a_verser = ''

                    this.successToast("Reversement dépôt effectué avec succès")
                } else {
                    if (response.code == 500) {
                        this.warningToast("Une erreur s'est produite !")
                    }
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.warningToast("Une erreur s'est produite !")
            })
        },

        clearError() {
            this.error_message = ''
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.search_filter.page = this.currentPage
                this.getListePatients()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.search_filter.page = this.currentPage
                this.getListePatients()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.search_filter.page = this.currentPage
                this.getListePatients()
            }
        },

        searchPatient() {
            this.search_filter.search_term = this.filter
            this.getListePatients()
        }
    }
}


